import { FactoryProvider, inject } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { AuthenticationFacadeService } from '@finverity/authentication';
import { CompanyType } from '@finverity/graphql';
import { FV_SIDEBAR_BOTTOM_ITEMS } from '@fv/ui-kit';

import { NAVIGATION_SIDEBAR_BOTTOM_MENU_ITEMS } from '../constants';
import { NavigationSidebarBottomMenuItem } from '../types';
import { isMenuItemHiddenInEnvironment, selectLinkedBottomMenuItems } from '../utils';

function isMenuItemCompatibleWithAuthUserCompanyType(
  menuItem: NavigationSidebarBottomMenuItem,
  authCompanyType: CompanyType
): boolean {
  return !menuItem.companyTypes || menuItem.companyTypes.includes(authCompanyType);
}

function filterBottomMenuItemsByCompanyType(
  menuItems: NavigationSidebarBottomMenuItem[],
  companyType: CompanyType
): NavigationSidebarBottomMenuItem[] {
  return menuItems.filter(
    item =>
      isMenuItemCompatibleWithAuthUserCompanyType(item, companyType) && !isMenuItemHiddenInEnvironment(item.identifier)
  );
}

function navigationSidebarMenuBottomSectionItemsFactory(): NavigationSidebarBottomMenuItem[] {
  const authUser = inject(AuthenticationFacadeService).userSignal();
  const translocoService = inject(TranslocoService);

  const filteredItems = filterBottomMenuItemsByCompanyType(
    NAVIGATION_SIDEBAR_BOTTOM_MENU_ITEMS,
    authUser?.company_type as CompanyType
  );

  // `<fv-sidebar>` renders `item.title` raw, so resolve the i18n keys here.
  return selectLinkedBottomMenuItems(filteredItems).map(item => ({
    ...item,
    title: translocoService.translate(item.title),
  }));
}

export function provideNavigationSidebarMenuBottomSectionItems(): FactoryProvider {
  return {
    provide: FV_SIDEBAR_BOTTOM_ITEMS,
    useFactory: navigationSidebarMenuBottomSectionItemsFactory,
  };
}
